module.exports = {
	"id": "/event_starts",
	"type": "object",
	"properties": {
		"sportId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"eventId": {
			"type": "integer",
			"required": true
		},
		"minutes": {
			"type": "integer",
			"required": true
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/event_starts.json
 ** module id = 1831
 ** module chunks = 0
 **/